
<template>
  <div class="p-3">

    <div v-if="loaded">
      <div class="row">
        <div class="col-12 col-md-4 mt-3">
          <label>Ενεργός κύκλος</label>
          <b-form-input v-model="activeCycle.cycle" placeholder="π.χ. A"/>
        </div>
        <div class="col-12 col-md-4 mt-3">
          <label>Ημερομηνία έναρξης κύκλου</label>
          <b-form-input v-model="activeCycle.startDate" type="date"/>
        </div>
        <div class="col-12 col-md-4 mt-3">
          <label>Ημερομηνία λήξης κύκλου</label>
          <b-form-input v-model="activeCycle.endDate" type="date"/>
        </div>
        <div class="col-12 col-md-4 mt-3">
          <label>Ημέρα παράδοσης</label>
          <b-form-select v-model="dayOfDelivery">
            <option :value="0">Κυριακή</option>
            <option :value="1">Δευτέρα</option>
            <option :value="2">Τρίτη</option>
            <option :value="3">Τετάρτη</option>
            <option :value="4">Πέμπτη</option>
            <option :value="5">Παρασκευή</option>
            <option :value="6">Σάββατο</option>
          </b-form-select>
        </div>
      </div>

      <hr class="my-4"/>
      <h6 class="font-weight-bold">Ρυθμίσεις χρονοδιαγράμματος</h6>
      <div class="row">
        <div class="col-12 col-md-4 mt-3">
          <label>Ημέρα κλειδώματος παραγγελιών</label>
          <b-form-select v-model="orderSettings.lockDay">
            <option :value="0">Κυριακή</option>
            <option :value="1">Δευτέρα</option>
            <option :value="2">Τρίτη</option>
            <option :value="3">Τετάρτη</option>
            <option :value="4">Πέμπτη</option>
            <option :value="5">Παρασκευή</option>
            <option :value="6">Σάββατο</option>
          </b-form-select>
        </div>
        <div class="col-12 col-md-4 mt-3">
          <label>Ώρα κλειδώματος</label>
          <b-form-input v-model="orderSettings.lockHour" type="number" min="0" max="23" placeholder="π.χ. 18"/>
        </div>
        <div class="col-12 col-md-4 mt-3">
          <label>Ημέρες πριν παράδοση → Αναμονή πληρωμής</label>
          <b-form-input v-model="orderSettings.daysToPendingPayment" type="number" min="1" placeholder="π.χ. 6"/>
        </div>
        <div class="col-12 col-md-4 mt-3">
          <label>Ημέρες πριν παράδοση → Αυτόματη ακύρωση</label>
          <b-form-input v-model="orderSettings.daysToCancelled" type="number" min="1" placeholder="π.χ. 3"/>
        </div>
        <div class="col-12 col-md-4 mt-3">
          <label>Ελάχιστες ημέρες για νέα παραγγελία</label>
          <b-form-input v-model="orderSettings.minDaysForDelivery" type="number" min="1" placeholder="π.χ. 4"/>
        </div>
        <div class="col-12 col-md-4 mt-3">
          <label>Μέγιστες ημέρες στο μέλλον</label>
          <b-form-input v-model="orderSettings.maxDaysInFuture" type="number" min="1" placeholder="π.χ. 28"/>
        </div>
      </div>

      <hr class="my-4"/>
      <h6 class="font-weight-bold">Εναλλαγή κύκλων προϊόντων</h6>
      <div class="d-flex align-items-center" style="gap:10px">
        <b-button variant="warning" @click="rotateCycles('forward')" :disabled="rotating">
          ← Πίσω (B→A, C→B, D→C, A→D)
        </b-button>
        <b-button variant="info" @click="rotateCycles('backward')" :disabled="rotating">
          Μπροστά (A→B, B→C, C→D, D→A) →
        </b-button>
        <span v-if="rotating" class="ml-2">Εκτέλεση...</span>
      </div>

      <div class="mt-4 text-right">
        <b-button variant="success" @click="saveChanges">Αποθήκευση</b-button>
      </div>
    </div>
    <div v-else class="text-center py-4">Φόρτωση...</div>

  </div>

</template>

<script>
export default{

  mounted(){
    this.getCycleInformation();
  },
  methods:{
    getCycleInformation(){
      this.axios.get('/admin/settings/active_cycle,day_of_delivery,order_settings').then(res=>{
        for(let setting of res.data){
          if(setting.key === 'active_cycle'){
            this.activeCycle = setting.value;
          } else if(setting.key === 'day_of_delivery'){
            this.dayOfDelivery = setting.value;
          } else if(setting.key === 'order_settings'){
            this.orderSettings = { ...this.orderSettings, ...setting.value };
          }
        }
        this.loaded = true;
      }).catch(()=>{
        this.$notify({type: 'error', title:'Σφάλμα', text: 'Δεν ήταν δυνατή η φόρτωση των ρυθμίσεων.'});
      });
    },
    rotateCycles(direction){
      const label = direction === 'forward' ? 'B→A, C→B, D→C, A→D' : 'A→B, B→C, C→D, D→A';
      if (!confirm(`Θέλετε σίγουρα να εναλλάξετε τους κύκλους όλων των προϊόντων; (${label})`)) return;
      this.rotating = true;
      this.axios.post('/admin/products/rotate-cycles', { direction }).then(res => {
        this.$notify({type: 'success', title:'Επιτυχία', text: `Ενημερώθηκαν ${res.data.updated} προϊόντα.`});
      }).catch(() => {
        this.$notify({type: 'error', title:'Σφάλμα', text: 'Δεν ήταν δυνατή η εναλλαγή κύκλων.'});
      }).finally(() => {
        this.rotating = false;
      });
    },
    saveChanges(){
      Promise.all([
        this.axios.put('/admin/settings/active_cycle', { value: this.activeCycle }),
        this.axios.put('/admin/settings/day_of_delivery', { value: this.dayOfDelivery }),
        this.axios.put('/admin/settings/order_settings', { value: this.orderSettings }),
      ]).then(() => {
        this.$notify({type: 'success', title:'Επιτυχία', text: 'Οι ρυθμίσεις αποθηκεύτηκαν.'});
      }).catch(() => {
        this.$notify({type: 'error', title:'Σφάλμα', text: 'Δεν ήταν δυνατή η αποθήκευση.'});
      });
    }
  },
  data(){
    return{
      loaded: false,
      rotating: false,
      activeCycle: {
        cycle: null,
        startDate: null,
        endDate: null,
      },
      dayOfDelivery: null,
      orderSettings: {
        lockDay: 4,
        lockHour: 18,
        daysToPendingPayment: 6,
        daysToCancelled: 3,
        minDaysForDelivery: 4,
        maxDaysInFuture: 28,
      },
    }
  },
}
</script>
